import { Injectable } from '@angular/core';
import { RequestService } from '../request.service';
import { Auth } from '../auth.service';
import { Medicine } from '../../classes/medicine';
import { VademecumInfo } from '../../classes/vademecumInfo';

@Injectable()
export class MedicinesService {

  constructor(protected requestService: RequestService, protected auth: Auth) { }

  info():Promise<VademecumInfo> {
    return this.requestService.makeRequest({}, '/medicines/vademecum').then((response: any) => response.json() as Array<VademecumInfo>);
  }

  find(query:string): Promise<Array<Medicine>> {
    return this.requestService.makeRequest({urlQueryParams: { active: query }}, '/medicine').then((response: any) => response.json() as Array<Medicine>);
  }

  update(forceMonthly): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'updateMedicines',
      method: 'put',
      urlQueryParams: {
        force: forceMonthly
      }
    });
  }
 
}



// WEBPACK FOOTER //
// ./src/app/services/medicines/medicines.service.ts